/* eslint-disable no-console */
import React, { Component } from 'react';
// import { LoginButton } from './LoginPage.style';

class ExportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleExportClick = this.handleExportClick.bind(this);
  }
  handleExportClick(evt) {
    evt.preventDefault();
    window.fetch(process.env.REACT_APP_SUBMISSION_EXPORT_API, {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.accessToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Export error');
        }
        return response.blob();
      }).then((blob) => {
        const objectURL = window.URL.createObjectURL(blob);
        window.location = objectURL;
      }).catch((err) => {
        console.log(err);
      });
  }
  render() {
    return (
      <div className="ncss-container fixed-fluid">
        <div className="ncss-row">
          <div className="ncss-col-sm-12 mt6-sm mb8-sm ta-sm-c">
            <a
              onClick={this.handleExportClick}
              href={process.env.REACT_APP_SUBMISSION_EXPORT_API}
              style={{
              background: '#061b38',
              color: '#ffffff',
              // boxShadow: '0 0 0px 1.5px #061B38',
              padding: '1em 4em',
              margin: '1em',
              display: 'inline-block',
              borderRadius: '5em',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
            >
            Export
            </a>
            {/* <h5 style={{ margin: '15em 3em 0', color: '#CCC', textAlign: 'left' }}>{authUrl}</h5> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ExportPage;



// WEBPACK FOOTER //
// ./src/containers/ExportPage/ExportPage.js